// extracted by mini-css-extract-plugin
export var hideEditor = "_le-2";
export var infoIcon = "_le-3";
export var label = "_le-1";
export var labelContainer = "_le-0";
export var readonlyText = "_le-4";